// Viewport-driven size tweaks. Evaluated lazily so SSR / test environments
// without `window.matchMedia` don't blow up at import time. Crossing the
// breakpoint mid-session requires a page refresh — the controls bake their
// pixel size into a canvas backing store at construction.

const COMPACT_QUERY = "(max-width: 480px)";

export function isCompactViewport(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia(COMPACT_QUERY).matches
  );
}

/** Scale a px size down on phone-class viewports. `factor` defaults to
 *  0.78 — the empirical sweet spot for keeping a 72 px knob touch-friendly
 *  at a 56 px footprint without losing readout clarity. */
export function compactSize(px: number, factor = 0.78): number {
  return Math.round(isCompactViewport() ? px * factor : px);
}
